// React
import { FormEventHandler, useEffect, useState } from "react";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { signIn, signOut, confirmSignIn } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import { actions } from "@/redux/reducers/User";
import { actions as actionsLocation } from "@/redux/reducers/Location";
// Helpers
import { storageRemoveItem, storageSetItem } from "@/Common/helpers/Storage";
import { errorLogger, getError } from "@/Common/helpers/logger";
// Components
import ResetPassword from "@Auth/Layouts/ResetPassword";
// Types
import { UserWrapper } from "@Auth/types";
import { INITIAL_RESET_PASSWORD_STATE } from "@Auth/constants";

export default function NewPassword() {
	const localUser = useSelector<{ user: UserWrapper }, UserWrapper>((item) => item.user);
	const navigate = useNavigate();
	const search = window.location.search;
	const params = new URLSearchParams(search);
	const userNameParams = params.get("u") ?? "";
	const passwordParams = params.get("p") ?? "";
	const dispatch = useDispatch();

	const [state, setState] = useState(INITIAL_RESET_PASSWORD_STATE);

	const routeChange = () => {
		storageSetItem("userName", state.username || "");
		navigate("/login");
	};

	const handleSubmit: FormEventHandler = (event) => {
		event.preventDefault();

		setState((oldValues) => ({
			...oldValues,
			isLoading: true,
		}));

		signIn({ username: userNameParams, password: passwordParams })
			.then(({ nextStep }) => {
				if (nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
					confirmSignIn({ challengeResponse: state.password, options: {} })
						.then(() => {
							routeChange();
							setState((oldValues) => ({
								...oldValues,
								isLoading: false,
							}));
							storageRemoveItem("loggedUser");
							storageRemoveItem("location");
							dispatch(actions.SET_USER({ user: null }));
							dispatch(actionsLocation.SET_LOCATION({ location: null }));
							signOut({ global: true });
						})
						.catch((e) => {
							errorLogger(getError(e));
						});
				} else {
					// other situations
				}
			})
			.catch((err) => {
				setState({
					...state,
					message: "Something went wrong, please contact DAS team to request new access.",
					error: true,
					isLoading: false,
				});
				errorLogger(getError(err));
			});
	};

	useEffect(() => {
		if (localUser.user) {
			navigate("/");
		}

		return () => {
			setState(INITIAL_RESET_PASSWORD_STATE);
		};
	}, [localUser, navigate]);

	return <ResetPassword title="Create New Password" state={state} handleSubmit={handleSubmit} updateState={setState} />;
}
